<template>
     <div class="realstate-search">
          <PageTitle icon="fa fa-clone" main="Record" sub="Real State" />
            <b-form v-show="mode === 'save' || mode === 'remove' || mode === 'read'" >
             <input id="realstate-id" type="hidden" v-model="realstate.id" />
             <b-row>
                <b-col md="5" sm="12">
                    <b-form-group 
                        label="Name:" 
                        label-for="realstate-name_real_state">
                        <b-form-input 
                            id="realstate-name_real_state" 
                            type="text" 
                            ref="searchFocus"
                            v-model="realstate.name_real_state" 
                            required
                            size="sm"
                            :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            placeholder="Name..." />
                    </b-form-group>
                </b-col>   
                <b-col md="6" sm="12">
                    <b-form-group 
                        label="Address:" 
                        label-for="realstate-adress_real_state">    
                        <b-form-input
                            id="realstate-adress_real_state" 
                            type="text"
                            v-model="realstate.adress_real_state" 
                            required
                            size="sm"
                            :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            placeholder="Address..." />  
                    </b-form-group>
                </b-col>
                <b-col md="1" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                            <input class="form-check-input" 
                                v-model="realstate.blocked_real_state" 
                                true-value="1" false-value="0" 
                                type="checkbox" 
                                id="realstate-blocked_real_state"
                                :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            >
                            <label class="form-check-label" for="realstate-blocked_real_state">
                                Blocked?
                            </label>
                        </div>
                    </div>
                </b-col>  
              
             </b-row>
            <b-card class="realstate-search-card">
                    <b-tabs card >
                    <b-tab title="Contact" active>
                        <b-form>
                            <b-row>
                                 <b-col md="5" sm="12">
                                    <b-form-group 
                                        label="E-mail:" 
                                        label-for="realstate-email_contact_real_state">
                                        <b-form-input 
                                        id="realstate-email" type="text"
                                        v-model="realstate.email_contact_real_state" 
                                        size="sm"
                                        :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                                        placeholder="E-mail" />
                                    </b-form-group>
                                </b-col>
                                <b-col md="3" sm="12">
                                    <b-form-group 
                                        label="Phone number:" 
                                        label-for="realstate-phone_contact_real_state">
                                        <b-form-input 
                                            id="realstate-phone_contact_real_state" 
                                            type="text"
                                            v-model="realstate.phone_contact_real_state" 
                                          size="sm"
                                        :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                                        placeholder="Phone number" />
                                    </b-form-group>
                                </b-col>
                            </b-row>   
                        </b-form>
                        </b-tab>
                        <b-tab title="Property Location">
                         <b-row>
                              <b-button  
                            title="Add Location" 
                            size="sm" 
                            class="mb-2 fa fa-plus" 
                            variant="dark" 
                            v-if="realstate.id > 0"
                            @click="[realstatelocation = {}, openModalLocation()]">
                        </b-button>
                        </b-row>   
                        <b-row>
                            <b-col md="6" sm="12">    
                              <transition  name="slide" type="animation" appear>       
                        <b-table 
                            class="table-responsive" 
                            hover 
                            key="slide"  
                            head-variant="light" 
                            :items="realstatelocations" 
                            :fields="fieldLocation">

                        <template v-slot:cell(actions)="data">
                             <b-button 
                                title="Add Service" 
                                size="sm" 
                                variant="light" 
                                @click="[loadOwnerLocation(data.item),openModalDefaultService()]" class="mr-2 mt-2">
                                <i class="fa fa-plus"></i>
                             </b-button>
                             <b-button 
                                title="Service Details" 
                                size="sm" 
                                variant="light" 
                                @click="[loadOwnerLocation(data.item),loadOwnerDefaultServices()]" class="mr-2 mt-2">
                                <i class="fa fa-external-link"></i>
                            </b-button>
                            <b-button 
                                title="Edit" 
                                size="sm" 
                                variant="light" 
                                @click="[loadOwnerLocation(data.item),openModalLocation()]" class="mr-2 mt-2">
                                <i class="fa fa-pencil"></i>
                            </b-button>
                            <b-button 
                                title="Delete" 
                                size="sm" 
                                variant="light" 
                                @click="showMsgBoxDeleteLocation(data.item)" 
                                class="mr-2 mt-2">
                            <i class="fa fa-trash"></i>
                            </b-button>
                        </template>
                        </b-table>
                        </transition>  
                        </b-col>
                             <b-col md="6" sm="12">
                                <transition  name="slide" type="animation" appear> 
                                     <b-table 
                                     v-show="showTableDefault"
                                    class="table-responsive" 
                                    hover 
                                    key="slide"  
                                    head-variant="light" 
                                    :items="realstatelocationdefaultservices" 
                                    :fields="fieldDefaultService">
                                    <template v-slot:cell(actions)="data">
                                         <b-button  
                                            title = "Open Order Service" 
                                            size="sm" 
                                            variant="light" 
                                            @click="[loadOwnerDefaultService(data.item, 'read'),openModalOrderService()]" 
                                            class="mr-2 mt-2">
                                            <i class="fa fa-plus"></i>
                                        </b-button>
                                        <b-button 
                                            title="Edit" 
                                            size="sm" 
                                            variant="light" 
                                            @click="[loadOwnerDefaultService(data.item),openModalDefaultService()]" class="mr-2 mt-2">
                                            <i class="fa fa-pencil"></i>
                                        </b-button>
                                        <b-button 
                                            title="Delete" 
                                            size="sm" 
                                            variant="light" 
                                            @click="showMsgBoxDeleteDefaultService(data.item)" 
                                            class="mr-2 mt-2">
                                        <i class="fa fa-trash"></i>
                                        </b-button>
                                 </template>
                                     </b-table>

                                </transition>
                        </b-col>
                        </b-row>
                        </b-tab>
                        <b-tab title="Order Service">
                            <b-table 
                                    class="table-responsive" 
                                    hover 
                                    head-variant="dark" 
                                    :items="orderservices" 
                                    :fields="fieldsOrderService">
                                <template v-slot:cell(actions)="data">
                                        <b-button  
                                            title = "Edit" 
                                            size="sm" 
                                            variant="light" 
                                            @click="[loadOrderService(data.item),openModalOrderService()]" 
                                            class="mr-2 mt-2">
                                            <i class="fa fa-pencil"></i>
                                        </b-button>
                                    </template>    
                            </b-table> 
                        </b-tab>
                    </b-tabs>
                    
                </b-card>
        <br>
         </b-form>

            <hr v-show="mode === 'save'">
              <b-row>
                <b-col xs="12">
                   <b-button  
                        size="sm" 
                        variant="light" 
                        title="Add"
                        class="mt-2  mb-2 fa fa-plus" 
                        v-show="mode !== 'save' && mode !== 'remove'"
                        @click="alterModo">
                    </b-button>
                    <b-button 
                        size="sm" 
                        variant="light"
                         title="Save"
                        class="mt-2 mb-2 ml-2 fa fa-save" 
                        v-if="mode === 'save'"
                        @click="save">
                        </b-button>
                    <b-button 
                        size="sm" 
                        variant="light" 
                         title="Delete"
                        class="mt-2 mb-2 ml-2 fa fa-trash" 
                        v-if="mode === 'remove'"
                        @click="remove">
                    </b-button>
                    <b-button 
                        size="sm" 
                        btn-sm 
                        variant="light" 
                         title="Back"
                        class="mt-2 mb-2 ml-2 fa fa-mail-reply"  
                        v-if="mode === 'remove' || mode === 'save' || mode === 'read' "
                        @click="reset">
                    </b-button>
                    <b-button 
                         size="sm" 
                         class="mt-2 mb-2 ml-2 fa" 
                          title="Search"
                         :class="icon" 
                         @click="[loadOwners(),toggleBusy(),showTable = !showTable]" 
                         variant="light" >
                    </b-button>
                </b-col>
            </b-row>
            <br>
            <b-row v-show="mode !== 'save' && mode !== 'remove'">
                   <div class="col-sm-4">
                    <div class="form-group">
                        <input 
                            type="text" 
                            size="sm" 
                            icon="search" 
                            v-model="search" 
                           
                              v-show="mode !== 'save' && mode !== 'remove'"
                            placeholder="Search by real state name" 
                            class="form-control">
                    </div>
                </div>  
          <transition  name="slide" type="animation" appear>       
         <b-table 
                 :busy="isBusy"  
                class="table-responsive" 
                :per-page="perPage" 
                :current-page="currentPage" 
                hover 
                 head-variant="dark" 
                v-show="showTable"
                :items="filteredList" 
                :fields="fields">
                <template v-slot:table-busy>
                    <div class="text-center text-info my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                    </div>
                </template>
               <template v-slot:cell(actions)="data">
                    <b-button  
                        title = "View" 
                        size="sm" 
                        variant="light" 
                        @click="loadOwner(data.item, 'read')" 
                        class="mr-2 mt-2">
                        <i class="fa fa-drivers-license-o"></i>
                    </b-button>
                    <b-button  
                        title = "Edit" 
                        size="sm" 
                        variant="light" 
                        @click="loadOwner(data.item)" 
                        class="mr-2 mt-2">
                        <i class="fa fa-pencil"></i>
                    </b-button>
                     <b-button  
                        title = "Delete" 
                        size="sm" 
                        variant="light" 
                        @click="loadOwner(data.item, 'remove')" class="mr-2 mt-2">
                        <i class="fa fa-trash"></i>
                    </b-button>
                </template>    
         </b-table> 
          </transition>
          <transition  name="slide" type="animation" appear>
            <b-pagination
                v-show="showTable"
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                size="sm"
                aria-controls="my-table"
            ></b-pagination>
          </transition>
    </b-row>
     <b-modal
            id="modalLocation"
            ref="modal"
            title-tag="h6"
            title="Location"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="saveLocation"
        >
            <b-form>
                <b-row>
                    <b-col md="12" sm="12">
                        <b-form-group
                            label="Address:"
                            label-for="realstatelocation-address_location"
                        >
                            <b-form-input
                                id="realstatelocation-address_location"
                                v-model="realstatelocation.address_location"
                                type="text"
                                size="sm"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                <b-col md="1" sm="12">
                    <div class="form-group">
                    <div class="form-check">
                        <input class="form-check-input" 
                            v-model="realstatelocation.blocked_location" 
                            true-value="1" false-value="0" 
                            type="checkbox" 
                            id="realstatelocation-blocked_location"
                        >
                        <label 
                            class="form-check-label" 
                            for="realstatelocation-blocked_location">
                            Blocked?
                        </label>
                    </div>
                    </div>
                </b-col>  
            
                </b-row>
            </b-form>
        </b-modal>
         <b-modal
            id="modalDefaultService"
            ref="modal"
            title-tag="h6"
            title="Service Provided"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="saveDefaultService"
        >
          <b-form>
                <b-row>
                    <b-col md="12" sm="12">
                        <b-form-group
                            label="Service:"
                            label-for="realstatelocationdefaultservice-default_service_type_id_defualt_service"
                        >
                            <b-form-select
                                id="realstatelocationdefaultservice-default_service_type_id_defualt_service"
                                size="sm"
                                :options="typerealstatelocationdefaultservices"
                                v-model="realstatelocationdefaultservice.default_service_type_id_defualt_service"
                            />
                        </b-form-group>
                    </b-col>
                  </b-row>
                <b-row>
                    <b-col md="5" sm="12">
                        <div class="form-group">
                        <div class="form-check">
                            <input class="form-check-input" 
                                v-model="realstatelocationdefaultservice.service_payment_landlord_defualt_service" 
                                true-value="1" false-value="0" 
                                type="checkbox" 
                                id="realstatelocationdefaultservice-service_payment_landlord_defualt_service"
                            >
                            <label 
                                class="form-check-label" 
                                for="realstatelocationdefaultservice-service_payment_landlord_defualt_service">
                                Payment is made by the owner?
                            </label>
                        </div>
                        </div>
                    </b-col>  
                     <b-col md="2" sm="12">
                        <div class="form-group">
                        <div class="form-check">
                            <input class="form-check-input" 
                                v-model="realstatelocationdefaultservice.blocked_default_service" 
                                true-value="1" false-value="0" 
                                type="checkbox" 
                                id="realstatelocationdefaultservice-blocked_default_service"
                            >
                            <label 
                                class="form-check-label" 
                                for="realstatelocationdefaultservice-blocked_default_service">
                                Blocked?
                            </label>
                        </div>
                        </div>
                    </b-col>  
                </b-row>
          </b-form>
        </b-modal>
         <b-modal
            id="modalOrderService"
            ref="modal"
            title-tag="h6"
            title="Order Service"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="saveOrderService"
        >
          <b-form>
              <b-row>
                <b-col md="4" sm="12">
                    <b-form-group
                        label="Order Date:"
                        label-for="orderservice-date_order_service"
                        >
                        <b-form-input
                        id="orderservice-date_order_service"
                        type="date"
                        v-model="orderservice.date_order_service"
                        size="sm"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="4" sm="12">
                    <b-form-group
                        label="Date Scheduled:"
                        label-for="orderservice-date_scheduled_order_service"
                        >
                        <b-form-input
                        id="orderservice-date_scheduled_order_service"
                        type="date"
                        v-model="orderservice.date_scheduled_order_service"
                        size="sm"
                        />
                    </b-form-group>
                </b-col>
                 <b-col md="4" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                            <input class="form-check-input" 
                                v-model="orderservice.service_payment_fixed_order_service" 
                                true-value="1" false-value="0" 
                                type="checkbox" 
                                id="orderservice-service_payment_fixed_order_service"
                            >
                            <label class="form-check-label" for="orderservice-service_payment_fixed_order_service">
                                Paid service (Fixed Value)?
                            </label>
                        </div>
                    </div>
                </b-col>  
              </b-row>
              <b-row>
                <b-col md="12" sm="12">
                        <b-form-group
                            label="Service Provider Contract:"
                            label-for="orderservice-service_provider_contract_item_id_order_service"
                        >
                            <b-form-select
                                id="orderservice-service_provider_contract_item_id_order_service"
                                size="sm"
                                :options="serviceprovidecontractitems"
                                v-model="orderservice.service_provider_contract_item_id_order_service"
                            />
                        </b-form-group>
                    </b-col>
              </b-row>
              <b-row>
                 <b-col md="12" sm="12">
                        <b-form-group 
                            label="Comments:" 
                            label-for="orderservice-comments_order_service">
                        <b-form-textarea id="orderservice-comments_order_service"
                            :rows="3"
                            :max-rows="6"
                            size="sm"
                            v-model="orderservice.comments_order_service"
                            placeholder="Comments" />
                    </b-form-group>
                </b-col>
          
             </b-row>
          </b-form>
        </b-modal>   
            
     </div>
</template>

<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import PageTitle from '../template/PageTitle'

var moment = require('moment-timezone')

export default {
    name: 'RealStateSearch',
    components: {PageTitle },
    data: function() {
        return {
                mode: 'insert',
                search: '',
                realstate: {},
                realstatelocation: {},
                orderservice:{},
                realstatelocationdefaultservice: {},
                realstatelocationdefaultserviceitem: {},
                realstatelocations:[],
                realstatelocationdefaultservices:[],
                realstatelocationdefaultserviceitems:[],
                realstates: [],
                orderservices:[],
                serviceprovidecontractitems:[],
                typerealstatelocationdefaultservices: [],
                typepartrealstatelocationdefaultservices: [],
                perPage: 50,
                currentPage: 1,
                isBusy: false,
                showTable: false,
                showTableDefault: false,
                showTableItem: false,
                headerBgVariant: 'dark',
                headerTextVariant: 'light',
                bodyBgVariant: 'light',
                bodyTextVariant: 'dark',
                footerBgVariant: 'warning',
                footerTextVariant: 'dark',
                fields: [
                { key: 'name_real_state', label: 'Name', sortable: true,variant: 'light' },
                { key: 'adress_real_state', label: 'Address', sortable: true ,variant: 'light'},
                { key: 'email_contact_real_state', label: 'E-mail', sortable: false ,variant: 'light'},   
                { key: 'phone_contact_real_state', label: 'Phone number', sortable: false ,variant: 'light'},   
                { key: 'blocked_real_state', label: 'Blocked', sortable: false,
                        formatter: value => value ? 'Yes' : 'No' ,variant: 'light'},               
                { key: 'actions', label: 'Action',variant: 'light' },
                ],
                fieldLocation: [
                  { key: 'blocked_location', label: 'Blocked', sortable: false,
                        formatter: value => value ? 'Yes' : 'No' },
                { key: 'address_location', label: 'Address', sortable: true },              
                { key: 'actions', label: 'Action',variant: 'light' }
                ],
                fieldDefaultService:[
                    { key: 'name_default_service_type', label: 'Service', sortable: true },
                    { key: 'service_payment_landlord_defualt_service', label: 'Payment is made by the owner', sortable: false,
                        formatter: value => value ? 'Yes' : 'No' },  
                    { key: 'blocked_default_service', label: 'Blocked', sortable: false,
                        formatter: value => value ? 'Yes' : 'No' },     
                    { key: 'actions', label: 'Action',variant: 'light' }        
                
                ],
                fieldsOrderService:[
                    { key: 'number_order_service', label: 'Nº', sortable: false ,variant: 'light'},
                    {
                      key: 'date_order_service',label: 'Order Date',sortable: true,
                            formatter: value =>
                            value ? moment.utc(value).format('MM-DD-YYYY') : '',variant: 'light'
                    },
                     {
                        key: 'date_scheduled_order_service',label: 'Date Scheduled',sortable: true,
                            formatter: value =>
                            value ? moment.utc(value).format('MM-DD-YYYY') : '',variant: 'light'
                    },
                    { key: 'name_service_provider', label: 'Service Provider', sortable: false ,variant: 'light'},
                    { key: 'address_location', label: 'Location', sortable: false ,variant: 'light'},
                    { key: 'name_default_service_type', label: 'Service', sortable: false ,variant: 'light'},
                    { key: 'service_payment_fixed_order_service', label: 'Service Value Fixed', sortable: false,
                        formatter: value => value ? 'Yes' : 'No' ,variant: 'light'},     
                    { key: 'name_service_provider', label: 'Service Provider', sortable: false ,variant: 'light'},
                    { key: 'comments_order_service', label: 'Comments', sortable: false ,variant: 'light'},
                    { key: 'actions', label: 'Action',variant: 'light' },
               
                ]
        
            }
        },
        computed: {
            filteredList() {
                return this.realstates.filter(realstate => {
                    return realstate.name_real_state.toLowerCase().includes(this.search.toLowerCase())
                    })
            },
            compan(){
                return this.$store.state.compan
            },
            icon() {
            return this.showTable ? "fa-retweet" : "fa-search";
            },
            rows() {
                return this.realstates.length
            },
            user(){
                    return this.$store.state.user
            },
        },
        methods:{
            formatDateTime(date) {
                return moment(date)
                    .utcOffset(-3)
                    .format('YYYY-MM-DD LT')
            },
            formatDate(value) {
                return moment(value)
                    .format('YYYY-MM-DD')
            },
            toggleBusy() {
                this.isBusy = !this.isBusy
            },
            async showMsgBoxDeleteLocation(item) {
                this.boxCancel = ''
                this.$bvModal
                    .msgBoxConfirm('Do you want to delete the record?', {
                    title: 'Please confirm',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async value => {
                    this.boxCancel = value
                    if (this.boxCancel === true) {
                        await this.removeLocation(item)
                    }
                })
            },
             async showMsgBoxDeleteDefaultService(item) {
                this.boxCancel = ''
                this.$bvModal
                    .msgBoxConfirm('Do you want to delete the record?', {
                    title: 'Please confirm',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async value => {
                    this.boxCancel = value
                    if (this.boxCancel === true) {
                        await this.removeDefaultService(item)
                    }
                })
            },
            loadOwners(){
                const url = `${baseApiUrl}/realstatesbycompany/${this.compan.id}`
                axios(url).then(res =>{
                     this.realstates = res.data
                      this.isBusy = false
                })
            },
            loadOwnerLocations(){
                const url = `${baseApiUrl}/realstatelocationsbyrealstate/${this.realstate.id}`
                axios(url).then(res =>{
                     this.realstatelocations = res.data
                })
            },
            loadOwnerDefaultServices(){
                const url = `${baseApiUrl}/realstatelocationdefaultservicesbyrealstate/${this.realstatelocation.id}`
                axios(url).then(res =>{
                     this.realstatelocationdefaultservices = res.data
                     this.showTableDefault = true
                })
            },
            alterModo() {
                    this.mode = 'save'
                    this.realstate = {}
                    this.realstatelocation = {}
                    this.realstatelocationdefaultservice = {}
                    this.realstatelocations = []
                    this.realstatelocationdefaultservices = []
                    this.$refs.searchFocus.focus();
            },
             reset() {
                this.mode = 'insert'
                this.loadOwners()
                this.realstatelocations = []
                this.realstatelocationdefaultservices = []
                this.realstate = {}
            },
            async save() {

                const method = this.realstate.id ? 'put' : 'post'
                const id = this.realstate.id ? `/${this.realstate.id}` : ''

                if(this.realstate.id){
                    this.realstate.update_date_real_state = this.formatDate(Date())
                    this.realstate.update_user_id_rea_lstate = this.user.id
                }else{
                    this.realstate.user_id_real_state = this.user.id
                    this.realstate.company_id_real_state = this.compan.id
                }

                await axios[method](`${baseApiUrl}/realstates${id}`, this.realstate)
                    .then(async () => {
                        this.$toasted.global.defaultSuccess()
                        this.reset()
                    })
                    .catch(showError)
            },
            async saveLocation() {

                    if (this.realstatelocation.id) {
                        this.realstatelocation.update_user_id_location = this.user.id
                        this.realstatelocation.update_date_location = this.formatDate(Date())
                    } else {
                        this.realstatelocation.user_id_location = this.user.id
                    }

                    const method = this.realstatelocation.id ? 'put' : 'post'
                    const id = this.realstatelocation.id ? `/${this.realstatelocation.id}` : ''
                    this.realstatelocation.real_state_id_location = this.realstate.id
                    await axios[method](
                        `${baseApiUrl}/realstatelocations${id}`,
                        this.realstatelocation
                    )
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.realstatelocation = {}
                            this.loadOwnerLocations()
                        })
                        .catch(showError)
            },
            async saveDefaultService() {

                    if (this.realstatelocationdefaultservice.id) {
                        this.realstatelocationdefaultservice.update_user_id_defualt_service = this.user.id
                        this.realstatelocationdefaultservice.update_date_defualt_service = this.formatDateTime(Date())
                    } else {
                        this.realstatelocationdefaultservice.user_id_defualt_service = this.user.id
                    }

                    const method = this.realstatelocationdefaultservice.id ? 'put' : 'post'
                    const id = this.realstatelocationdefaultservice.id ? `/${this.realstatelocationdefaultservice.id}` : ''
                    this.realstatelocationdefaultservice.real_state_location_id_default_service = this.realstatelocation.id
                    await axios[method](
                        `${baseApiUrl}/realstatelocationdefaultservices${id}`,
                        this.realstatelocationdefaultservice
                    )
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.realstatelocationdefaultservice = {}
                            this.realstatelocationdefaultserviceitems = []
                            this.loadOwnerDefaultServices()
                        })
                        .catch(showError)
            },
            remove() {
                    const id = this.realstate.id
                    axios.delete(`${baseApiUrl}/realstates/${id}`)
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.reset()
                        })
                        .catch(showError)
            },
           async removeLocation(item) {
                    axios.delete(`${baseApiUrl}/realstatelocations/${item.id}`)
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.loadOwnerLocations()
                        })
                        .catch(showError)
            },
           async removeDefaultService(item) {
                    axios.delete(`${baseApiUrl}/realstatelocationdefaultservices/${item.id}`)
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.loadOwnerDefaultServices()
                        })
                        .catch(showError)
            },

            loadOwner(realstate, mode = 'save') {
                this.mode = mode
                this.realstate = { ...realstate }
                this.$refs.searchFocus.focus();
                this.loadOwnerLocations()
                this.loadOrderServices()
                this.realstatelocationdefaultserviceitems = []
                this.showTableItem = false
            },
            loadOwnerLocation(item){
                this.realstatelocation = {...item}
            },
            loadOwnerDefaultService(item){
                this.realstatelocationdefaultservice = {...item}
                this.loadServiceProviderContract()
            },
            loadOwnerDefaultServiceItem(item){
                this.realstatelocationdefaultserviceitem = {...item}
            },
            openModalLocation() {
                this.realstatelocationdefaultservices = []
                this.$bvModal.show('modalLocation')
            },
            openModalOrderService(){

                this.orderservice.date_order_service =  moment().format('YYYY-MM-DD')
                this.$bvModal.show('modalOrderService')
            },
            openModalDefaultService() {
                this.$bvModal.show('modalDefaultService')
            },
            loadTypeDefaultService() {
                const url = `${baseApiUrl}/defaultservicetypesbycompany/${this.compan.id}`
                axios.get(url).then(res => {
                    this.typerealstatelocationdefaultservices = res.data.map(type => {
                        return { value: type.id, text: type.name_default_service_type }
                    })
                })
            },
            loadOrderService(item){
                this.orderservice = {...item}
                this.loadServiceProviderContract()
            },
            async saveOrderService(){
                 const method = this.orderservice.id ? 'put' : 'post'
                const id = this.orderservice.id ? `/${this.orderservice.id}` : ''

                if(this.orderservice.id){
                    this.orderservice.update_date_order_service = this.formatDate(Date())
                    this.orderservice.update_user_order_service = this.user.id
                }else{
                    this.orderservice.user_id_order_service = this.user.id
                    this.orderservice.company_id_order_service = this.compan.id
                    this.orderservice.real_state_id_order_service = this.realstate.id
                    this.orderservice.default_service_type_id_order_service = this.realstatelocationdefaultservice.default_service_type_id_defualt_service
                    this.orderservice.real_state_location_id_order_service = this.realstatelocationdefaultservice.real_state_location_id_default_service
                }

                await axios[method](`${baseApiUrl}/orderservices${id}`, this.orderservice)
                    .then(() => {
                        this.$toasted.global.defaultSuccess()
                        this.reset()
                    })
                    .catch(showError)
            },
            loadServiceProviderContract() {

                const default_service = this.realstatelocationdefaultservice.default_service_type_id_defualt_service ? this.realstatelocationdefaultservice.default_service_type_id_defualt_service : this.orderservice.default_service_type_id_order_service

                 const url = `${baseApiUrl}/serviceprovidecontractitemsbydefaultservices/${this.compan.id}/?default_service_type_id=${default_service}`
                axios.get(url).then(res => {
                    this.serviceprovidecontractitems = res.data.map(type => {
                        return { value: type.id, text: type.name_service_provider + ' - Price: ' + ' Fixed: ' + type.fixed_value_contract_item + ' |' + ' Hourly: ' + type.hourly_rate_contract_item }
                    })
                })
            },
            loadOrderServices(){
                const url = `${baseApiUrl}/realstatesbyorderservice/${this.realstate.id}`
                axios(url).then(res =>{
                     this.orderservices = res.data
                })
            },

        },
        mounted(){
            this.loadOwners()
            this.loadTypeDefaultService()
            this.showTable = true
            this.showTableItem = false
    
        }
}
</script>

<style>


    .realstate-search{
        font-size: 0.75rem;
        color: white;
   
    }

    .realstate-search button{
        font-size: 0.75rem;
    }

     .realstate-search select{
        font-size: 0.75rem;
    }

    .realstate-search input{
        font-size: 0.75rem;
    }

    .realstate-search-card label{
        font-size: 0.75rem;
        color: black;
   
    }



    #modalLocation {
        font-size: 0.75rem;
    }

    #modalLocation button{
        font-size: 0.75rem;
    }

     #modalLocation input{
        font-size: 0.75rem;
    }

      #modalLocation label{
        font-size: 0.75rem;
        color: black;
    }

     #modalDefaultService {
        font-size: 0.75rem;
    }

    #modalDefaultService button{
        font-size: 0.75rem;
    }

     #modalDefaultService input{
        font-size: 0.75rem;
    }

      #modalDefaultService select{
        font-size: 0.75rem;
    }

      #modalDefaultService label{
        font-size: 0.75rem;
        color: black;
    }


     #modalDefaultServiceItem {
        font-size: 0.75rem;
    }

    #modalDefaultServiceItem button{
        font-size: 0.75rem;
    }

     #modalDefaultServiceItem input{
        font-size: 0.75rem;
    }

    #modalDefaultServiceItem select{
        font-size: 0.75rem;
    }

    #modalDefaultServiceItem label{
        font-size: 0.75rem;
        color: black;
    }

    #modalDefaultServiceItem textarea{
        font-size: 0.75rem;
    }

     #modalOrderService button{
        font-size: 0.75rem;
    }

     #modalOrderService input{
        font-size: 0.75rem;
    }

      #modalOrderService select{
        font-size: 0.75rem;
    }

      #modalOrderService textarea{
        font-size: 0.75rem;
    }

      #modalOrderService label{
        font-size: 0.75rem;
        color: black;
    }


    
@keyframes slide-in {
  from {
    transform: translateY(40px);
  }
  to {
    transform: translateY(0);
  }
}

@keyframes slide-out {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(40px);
  }
}

.slide-enter-active {
  animation: slide-in 1s ease;
  transition: opacity 1s;
}

.slide-leave-active {
  animation: slide-out 1s ease;
  transition: opacity 1s;
}

.slide-enter,
.slide-leave-to {
  opacity: 0;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

</style>
